export const getKorDate = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.getFullYear()}.${date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`}.${
    date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`
  }`;
};

//* INFO: 반복 종료 일자 표시
export const getKorDateForRecurring = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.getUTCFullYear()}.${date.getUTCMonth() + 1 > 9 ? date.getUTCMonth() + 1 : `0${date.getUTCMonth() + 1}`}.${
    date.getUTCDate() > 9 ? date.getUTCDate() : `0${date.getUTCDate()}`
  }`;
};

export const getTimeString = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
};

export const getKorTime = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.getHours() >= 12 ? "오후" : "오전"} ${
    date.getHours() > 12 ? date.getHours() - 12 : date.getHours()
  }시 ${date.getMinutes() < 10 ? "0" : ""}${date.getMinutes()}분`;
};

export const getKorTime_v2 = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.getHours() >= 12 ? "오후" : "오전"} ${date.getHours() > 12 ? date.getHours() - 12 : date.getHours()}:${
    date.getMinutes() < 10 ? "0" : ""
  }${date.getMinutes()}`;
};

export const getEngTime_v2 = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.getHours() >= 12 ? "PM" : "AM"} ${date.getHours() > 12 ? date.getHours() - 12 : date.getHours()}:${
    date.getMinutes() < 10 ? "0" : ""
  }${date.getMinutes()}`;
};

export const getDay = (dateString: string) => {
  const days = ["일", "월", "화", "수", "목", "금", "토"];
  const date = new Date(dateString);
  return days[date.getDay()];
};
